import React, {useContext, useEffect, useState} from 'react'
import '../../base/Theme.css'
import Card from "../card/Card";
import Progress from "./progress/Progress"
import Text from "../../base/text/Text";
import './SeatView.css';
import 'rc-slider/assets/index.css';
import {formatValue} from "../../../utils/Formatter";
import {playBell, playCall, playCheck, playClapping, playClock, playFold, playRaise} from "../../../utils/Sounds";
import {usePrevious, useSounds} from "../../../utils/Hooks";
import {Context} from "../../App";
import Space from "../../base/space/Space";

const SeatView = ({
                      upper,
                      seat,
                      timeLimit,
                      currentPlayer,
                      hand,
                      onTakeClick,
                      onLeaveClick,
                      onKickClick,
                      winnerCards,
                  }) => {

    const soundsAllowed = useSounds();
    const {soundsEnabled} = useContext(Context);

    const [timeProgress, setTimeProgress] = useState(0);
    const [hasTimePassed, setTimePassed] = useState(false);
    const [hasHalfTimePassed, setHalfTimePassed] = useState(false);

    const prevStatus = usePrevious(seat?.status);
    const prevPrize = usePrevious(seat?.prize);
    const prevIsPlaying = usePrevious(seat?.isPlaying);
    const prevHalfTimePassed = usePrevious(hasHalfTimePassed);

    useEffect(() => {
        if (!soundsAllowed || !soundsEnabled) return;

        if (seat?.status && prevStatus !== seat?.status) {
            if (seat?.status === "check") playCheck();
            if (seat?.status === "call") playCall();
            if (seat?.status === "fold") playFold();
            if (seat?.status === "raise") playRaise();
        }

        if (seat?.prize && prevPrize !== seat?.prize) {
            playClapping();
        }

        if (seat?.prize && prevPrize !== seat?.prize) {
            playClapping();
        }

        if (hasHalfTimePassed && prevHalfTimePassed !== hasHalfTimePassed) {
            playClock();
        }

        if (seat?.playerId === currentPlayer?.id && seat?.isPlaying && prevIsPlaying !== seat?.isPlaying) {
            playBell();
        }
    });

    useEffect(() => {
        const timeTimer = setInterval(() => {
            if (seat.isPlaying && seat?.timestamp) {
                const passedTime = new Date().getTime() - new Date(seat?.timestamp).getTime();
                setTimePassed(passedTime > timeLimit * 1000)
                setHalfTimePassed(passedTime > timeLimit / 2 * 1000)
                setTimeProgress(passedTime);
            }
        }, 24);
        return () => {
            clearInterval(timeTimer);
        }
    });

    const buildFreeSeat = () => {
        return (
            <div className="Seat">
                {(() => {
                    if (!upper) return <>
                        {buildBetAmount()}
                        {buildDealerBadge()}
                        <Space space={8}/>
                    </>
                })()}
                {(() => {
                    return <button className="FreeSeat" onClick={() => {
                        onTakeClick(seat);
                    }}>Sit
                    </button>
                })()}
                {(() => {
                    if (upper) return <>
                        <Space space={8}/>
                        {buildDealerBadge()}
                        {buildBetAmount()}
                    </>
                })()}
            </div>
        )
    };

    const buildTakenSeat = () => {
        return (
            <div className="Seat">
                {(() => {
                    if (!upper) return <>
                        {buildBetAmount()}
                    </>
                })()}
                {(() => {
                    return <button className="TakenSeat"/>
                })()}
                {(() => {
                    if (upper) return <>
                        {buildBetAmount()}
                    </>
                })()}
            </div>
        )
    };

    const buildLeave = () => {
        if (seat?.playerId === currentPlayer?.id) {
            return (
                <button className="LeaveButton" onClick={() => {
                    onLeaveClick(seat);
                }}>leave
                </button>
            )
        }

        return null;
    };

    const buildKick = () => {
        if (currentPlayer?.tableId && seat?.isPlaying && seat?.playerId !== currentPlayer?.id && hasTimePassed) {
            return (
                <button className="KickButton" onClick={() => {
                    onKickClick(seat);
                }}>kick
                </button>
            )
        }

        return null;
    };

    const buildBetAmount = () => {
        if (seat?.bet === 0) return null;

        const coinImage = require("../../../assets/coins.png").default;
        return (
            <div className="SeatBet">
                <img width={16} height={16} src={coinImage} alt="coin"/>
                <Text style={"TextAlignCenter SeatBetText"} text={formatValue(seat?.bet, "")}/>
            </div>
        );
    };


    const buildCards = () => {
        const isSittingOut = seat?.sitOutTime && !seat?.inGame;

        const card1Opacity = isSittingOut || seat?.status === "fold"
            || (winnerCards && !winnerCards?.includes(card1));
        const card2Opacity = isSittingOut || seat?.status === "fold"
            || (winnerCards && !winnerCards?.includes(card2));

        return (<div className="Cards">
            <Card card={card1} opacity={card1Opacity}/>
            <Card card={card2} opacity={card2Opacity}/>
            <Space space={8}/>
            {buildDealerBadge()}
        </div>);
    }

    const buildDealerBadge = () => {
        if (!seat?.isDealer) return null;

        return <Text style={"DealerBadge TextAlignCenter"} text="D"/>;
    };

    const buildPlayerDetails = () => {
        let playerMoneyStr;
        if (seat?.playerMoney <= 0) playerMoneyStr = "All in";
        else playerMoneyStr = formatValue(seat?.playerMoney);

        if (!seat?.inGame && !seat?.sitOutTime) playerMoneyStr = "Waiting";
        if (!seat?.inGame && seat?.sitOutTime) playerMoneyStr = "Sitting out";
        if (seat?.prize) playerMoneyStr = "Winner " + formatValue(seat?.prize, "");

        let playerDetailsClass = "PlayerDetails";
        if (seat?.isPlaying) playerDetailsClass += " GlowAnimation";

        let playerMoneyTextClass = "PlayerMoneyText";
        let playerStatusTextClass = "PlayerStatusText";
        if (seat?.status) {
            playerMoneyTextClass += " PlayerMoneyAnimation";
            playerStatusTextClass += " PlayerStatusAnimation";
        }

        return (
            <div className={playerDetailsClass}>
                <Text style="PlayerNameText" text={seat?.name}/>
                <div className="PlayerStatus">
                    <Text style={playerMoneyTextClass} text={playerMoneyStr}/>
                    <Text style={playerStatusTextClass} text={seat?.status}/>
                </div>
            </div>
        );
    }

    const buildProgress = () => {
        if (!seat?.isPlaying) return null;

        return <Progress style={"SeatProgress"} max={timeLimit * 1000} progress={timeProgress}/>
    }

    if (!seat?.playerId && currentPlayer?.tableId) {
        return buildTakenSeat();
    }
    if (!seat?.playerId && !currentPlayer?.tableId) {
        return buildFreeSeat();
    }

    // Determine cards to show
    let card1 = hand?.playerId === seat.playerId ? hand.card1 : seat.card1;
    let card2 = hand?.playerId === seat.playerId ? hand.card2 : seat.card2;

    // Root class
    let rootClass = "Seat ";
    if (upper) rootClass += "SeatTop";
    if (!upper) rootClass += "SeatBottom";

    return (
        <div className={rootClass}>
            {(() => {
                if (!upper) return <>
                    {buildBetAmount()}
                </>
            })()}
            {(() => {
                if (upper) {
                    return <>
                        {buildKick()}
                        {buildLeave()}
                        <Space space={4}/>
                    </>
                }
            })()}
            {buildCards()}
            {buildPlayerDetails()}
            {buildProgress()}
            {(() => {
                if (!upper) {
                    return <>
                        <Space space={4}/>
                        {buildLeave()}
                        {buildKick()}
                    </>
                }
            })()}
            {(() => {
                if (upper) return <>
                    {buildBetAmount()}
                </>
            })()}
        </div>
    );
}

export default SeatView;
